export const get_converted_value = (value) => {
  let valuedata = 0;
  if (value <= -10000001 && value < 0) {
    valuedata = 10;
  } else if (value <= -250001 && value >= -1000000) {
    valuedata = 9;
  } else if (value <= -100001 && value >= -250000) {
    valuedata = 8;
  } else if (value <= -50001 && value >= -100000) {
    valuedata = 7;
  } else if (value <= -1 && value >= -50000) {
    valuedata = 6;
  } else if (value >= 0 && value <= 50000) {
    valuedata = 5;
  } else if (value >= 50001 && value <= 100000) {
    valuedata = 4;
  } else if (value >= 100001 && value <= 250000) {
    valuedata = 3;
  } else if (value >= 250001 && value <= 1000000) {
    valuedata = 2;
  } else if (value >= 1000001) {
    valuedata = 1;
  } else {
    valuedata = 0;
  }
  return valuedata;
};

export const customencodeURIComponent = (stringdata) => {
  if (!stringdata) return "";

  return stringdata
    .normalize("NFKC")
    .replace(/\u00A0/g, " ")
    .replace(/[\u2013\u2014]/g, "-")
    .replace(/'/g, "%27");
};

export const customdecodeURIComponent = (stringdata) => {
  return stringdata && stringdata.replace(/%20/g, " ").replace(/%27/g, "'");
};

export const getOrdinalSuffix = (number) => {
  const j = number % 10;
  const k = number % 100;

  if (j === 1 && k !== 11) {
    return "st";
  }
  if (j === 2 && k !== 12) {
    return "nd";
  }
  if (j === 3 && k !== 13) {
    return "rd";
  }
  return "th";
};

export const get_npi_color_old = (finalvalue) => {
  let value = Math.round(finalvalue);
  let color = "";
  if (parseFloat(value) >= 91 && parseFloat(value) <= 100) {
    color = "#4d6a37";
  } else if (parseFloat(value) >= 81 && parseFloat(value) <= 90) {
    color = "#648d49";
  } else if (parseFloat(value) >= 71 && parseFloat(value) <= 80) {
    color = "#8daa78";
  } else if (parseFloat(value) >= 61 && parseFloat(value) <= 70) {
    color = "#b7d09c";
  } else if (parseFloat(value) >= 51 && parseFloat(value) <= 60) {
    color = "#cfdebe";
  } else if (parseFloat(value) >= 41 && parseFloat(value) <= 50) {
    color = "#f2df90";
  } else if (parseFloat(value) >= 31 && parseFloat(value) <= 40) {
    color = "#f9c467";
  } else if (parseFloat(value) >= 21 && parseFloat(value) <= 30) {
    color = "#ff8b24";
  } else if (parseFloat(value) >= 11 && parseFloat(value) <= 20) {
    color = "#ef4f09";
  } else if (parseFloat(value) >= 1 && parseFloat(value) <= 10) {
    color = "#c62733";
  } else {
    color = "#F9FADF";
  }

  return color;
};

export const get_npi_color = (finalvalue) => {
  let value = Number(((finalvalue / 100) * 5).toFixed(2));
  let color = "";
  if (parseFloat(value) >= 4.17 && parseFloat(value) <= 5) {
    color = "#4d6a37";
  } else if (parseFloat(value) >= 3.9 && parseFloat(value) <= 4.16) {
    color = "#648d49";
  } else if (parseFloat(value) >= 3.64 && parseFloat(value) <= 3.89) {
    color = "#8daa78";
  } else if (parseFloat(value) >= 3.32 && parseFloat(value) <= 3.63) {
    color = "#b7d09c";
  } else if (parseFloat(value) >= 2.99 && parseFloat(value) <= 3.31) {
    color = "#cfdebe";
  } else if (parseFloat(value) >= 2.61 && parseFloat(value) <= 2.98) {
    color = "#f2df90";
  } else if (parseFloat(value) >= 2.28 && parseFloat(value) <= 2.6) {
    color = "#f9cc7a";
  } else if (parseFloat(value) >= 2.12 && parseFloat(value) <= 2.27) {
    color = "#f0aa65";
  } else if (parseFloat(value) >= 1.85 && parseFloat(value) <= 2.11) {
    color = "#dd874b";
  } else if (parseFloat(value) >= 0 && parseFloat(value) <= 1.84) {
    color = "#cf6822";
  } else {
    color = "#F9FADF";
  }

  return color;
};
export const get_nvi_color = (value) => {
  let color = "";
  if (parseFloat(value) === 0) {
    color = "#F9FADF";
  }
  if (parseFloat(value) <= -10000001 && parseFloat(value) < 0) {
    color = "#4d6a37";
  } else if (parseFloat(value) <= -250001 && parseFloat(value) >= -1000000) {
    color = "#648d49";
  } else if (parseFloat(value) <= -100001 && parseFloat(value) >= -250000) {
    color = "#8daa78";
  } else if (parseFloat(value) <= -50001 && parseFloat(value) >= -100000) {
    color = "#b7d09c";
  } else if (parseFloat(value) <= -1 && parseFloat(value) >= -50000) {
    color = "#cfdebe";
  } else if (parseFloat(value) > 0 && parseFloat(value) <= 50000) {
    color = "#f2df90";
  } else if (parseFloat(value) >= 50001 && parseFloat(value) <= 100000) {
    color = "#f9cc7a";
  } else if (parseFloat(value) >= 100001 && parseFloat(value) <= 250000) {
    color = "#f0aa65";
  } else if (parseFloat(value) >= 250001 && parseFloat(value) <= 1000000) {
    color = "#dd874b";
  } else if (parseFloat(value) >= 1000001) {
    color = "#cf6822";
  } else {
    color = "#F9FADF";
  }
  return color;
};

export const get_price_color = (value) => {
  let color = "";

  if (parseFloat(value) > 0 && parseFloat(value) <= 750000) {
    color = "#4d6a37";
  } else if (parseFloat(value) >= 750001 && parseFloat(value) <= 1000000) {
    color = "#648d49";
  } else if (parseFloat(value) >= 1000001 && parseFloat(value) <= 1250000) {
    color = "#8daa78";
  } else if (parseFloat(value) >= 1250001 && parseFloat(value) <= 1500000) {
    color = "#b7d09c";
  } else if (parseFloat(value) >= 1500001 && parseFloat(value) <= 2000000) {
    color = "#cfdebe";
  } else if (parseFloat(value) >= 2000001 && parseFloat(value) <= 2500000) {
    color = "#f2df90";
  } else if (parseFloat(value) >= 2500001 && parseFloat(value) <= 3000000) {
    color = "#f9cc7a";
  } else if (parseFloat(value) >= 3000001 && parseFloat(value) <= 4000000) {
    color = "#f0aa65";
  } else if (parseFloat(value) >= 4000001 && parseFloat(value) <= 5000000) {
    color = "#dd874b";
  } else if (parseFloat(value) >= 5000001) {
    color = "#cf6822";
  } else {
    color = "#F9FADF";
  }

  return color;
};

export const get_school_color = (value) => {
  let color = "#F9FADF";
  if (value) {
    if (parseFloat(value) >= 9.05 && parseFloat(value) <= 10) {
      color = "#4d6a37";
    } else if (parseFloat(value) >= 8.05 && parseFloat(value) <= 9.04) {
      color = "#648d49";
    } else if (parseFloat(value) >= 7.05 && parseFloat(value) <= 8.04) {
      color = "#8daa78";
    } else if (parseFloat(value) >= 6.05 && parseFloat(value) <= 7.04) {
      color = "#b7d09c";
    } else if (parseFloat(value) >= 5.05 && parseFloat(value) <= 6.04) {
      color = "#cfdebe";
    } else if (parseFloat(value) >= 4.05 && parseFloat(value) <= 5.04) {
      color = "#f2df90";
    } else if (parseFloat(value) >= 3.05 && parseFloat(value) <= 4.04) {
      color = "#f9cc7a";
    } else if (parseFloat(value) >= 2.05 && parseFloat(value) <= 3.04) {
      color = "#f0aa65";
    } else if (parseFloat(value) >= 1.05 && parseFloat(value) <= 2.04) {
      color = "#dd874b";
    } else if (parseFloat(value) >= 0.1 && parseFloat(value) <= 1.04) {
      color = "#cf6822";
    } else {
      color = "#F9FADF";
    }
  }
  return color;
};

export const get_crime_color = (value) => {
  let finalval = parseFloat(value).toFixed(2);
  let color = "";

  if (parseFloat(finalval) >= 9.05 && parseFloat(finalval) <= 10) {
    color = "#4d6a37";
  } else if (parseFloat(finalval) >= 8.05 && parseFloat(finalval) <= 9.04) {
    color = "#648d49";
  } else if (parseFloat(finalval) >= 7.05 && parseFloat(finalval) <= 8.04) {
    color = "#8daa78";
  } else if (parseFloat(finalval) >= 6.05 && parseFloat(finalval) <= 7.04) {
    color = "#b7d09c";
  } else if (parseFloat(finalval) >= 5.05 && parseFloat(finalval) <= 6.04) {
    color = "#cfdebe";
  } else if (parseFloat(finalval) >= 4.05 && parseFloat(finalval) <= 5.04) {
    color = "#f2df90";
  } else if (parseFloat(finalval) >= 3.05 && parseFloat(finalval) <= 4.04) {
    color = "#f9cc7a";
  } else if (parseFloat(finalval) >= 2.05 && parseFloat(finalval) <= 3.04) {
    color = "#f0aa65";
  } else if (parseFloat(finalval) >= 1.05 && parseFloat(finalval) <= 2.04) {
    color = "#dd874b";
  } else if (parseFloat(finalval) >= 0.1 && parseFloat(finalval) <= 1.04) {
    color = "#cf6822";
  } else {
    color = "#F9FADF";
  }

  return color;
};

export const get_walk_color = (value) => {
  let color = "";

  if (parseFloat(value) >= 9.01 && parseFloat(value) <= 10) {
    color = "#4d6a37";
  } else if (parseFloat(value) >= 8.01 && parseFloat(value) <= 9.0) {
    color = "#648d49";
  } else if (parseFloat(value) >= 7.01 && parseFloat(value) <= 8.0) {
    color = "#8daa78";
  } else if (parseFloat(value) >= 6.01 && parseFloat(value) <= 7.0) {
    color = "#b7d09c";
  } else if (parseFloat(value) >= 5.01 && parseFloat(value) <= 6.0) {
    color = "#cfdebe";
  } else if (parseFloat(value) >= 4.01 && parseFloat(value) <= 5.0) {
    color = "#f2df90";
  } else if (parseFloat(value) >= 3.01 && parseFloat(value) <= 4.0) {
    color = "#f9cc7a";
  } else if (parseFloat(value) >= 2.01 && parseFloat(value) <= 3.0) {
    color = "#f0aa65";
  } else if (parseFloat(value) >= 1.01 && parseFloat(value) <= 2.0) {
    color = "#dd874b";
  } else if (parseFloat(value) >= 0.1 && parseFloat(value) <= 1) {
    color = "#cf6822";
  } else {
    color = "#F9FADF";
  }

  return color;
};

export const get_dom_color = (value) => {
  let color = "";

  if (parseFloat(value) >= 91) {
    color = "#c62733";
  } else if (parseFloat(value) >= 81 && parseFloat(value) <= 90) {
    color = "#ef4f09";
  } else if (parseFloat(value) >= 71 && parseFloat(value) <= 80) {
    color = "#ff8b24";
  } else if (parseFloat(value) >= 61 && parseFloat(value) <= 70) {
    color = "#f9c467";
  } else if (parseFloat(value) >= 51 && parseFloat(value) <= 60) {
    color = "#f2df90";
  } else if (parseFloat(value) >= 41 && parseFloat(value) <= 50) {
    color = "#cfdebe";
  } else if (parseFloat(value) >= 31 && parseFloat(value) <= 40) {
    color = "#b7d09c";
  } else if (parseFloat(value) >= 21 && parseFloat(value) <= 30) {
    color = "#8daa78";
  } else if (parseFloat(value) >= 11 && parseFloat(value) <= 20) {
    color = "#648d49";
  } else if (parseFloat(value) > 0 && parseFloat(value) <= 10) {
    color = "#4d6a37";
  } else {
    color = "#F9FADF";
  }
  return color;
};

export const get_appreciation_color = (value) => {
  let color = "";

  if (parseFloat(value) <= -20) {
    color = "#cf6822";
  } else if (parseFloat(value) >= -19.99 && parseFloat(value) <= -15) {
    color = "#dd874b";
  } else if (parseFloat(value) >= -14.99 && parseFloat(value) <= -10) {
    color = "#f0aa65";
  } else if (parseFloat(value) >= -9.99 && parseFloat(value) <= -5) {
    color = "#f9cc7a";
  } else if (parseFloat(value) >= -4.99 && parseFloat(value) < 0) {
    color = "#f2df90";
  } else if (parseFloat(value) > 0 && parseFloat(value) <= 4.99) {
    color = "#cfdebe";
  } else if (parseFloat(value) >= 5 && parseFloat(value) <= 9.99) {
    color = "#b7d09c";
  } else if (parseFloat(value) >= 10 && parseFloat(value) <= 14.99) {
    color = "#8daa78";
  } else if (parseFloat(value) >= 15 && parseFloat(value) <= 19.99) {
    color = "#648d49";
  } else if (parseFloat(value) >= 20) {
    color = "#4d6a37";
  } else {
    color = "#F9FADF";
  }

  return color;
};

export const get_all_amenties_color = (value) => {
  let color = "";

  if (parseFloat(value) >= 4.5) {
    color = "#4d6a37";
  } else if (parseFloat(value) >= 4 && parseFloat(value) <= 4.5) {
    color = "#648d49";
  } else if (parseFloat(value) >= 3.51 && parseFloat(value) <= 3.99) {
    color = "#8daa78";
  } else if (parseFloat(value) >= 3 && parseFloat(value) <= 3.5) {
    color = "#b7d09c";
  } else if (parseFloat(value) >= 2.51 && parseFloat(value) <= 2.99) {
    color = "#cfdebe";
  } else if (parseFloat(value) >= 2 && parseFloat(value) <= 2.5) {
    color = "#f2df90";
  } else if (parseFloat(value) >= 1.51 && parseFloat(value) <= 1.99) {
    color = "#f9cc7a";
  } else if (parseFloat(value) >= 1 && parseFloat(value) <= 1.5) {
    color = "#f0aa65";
  } else if (parseFloat(value) >= 0.51 && parseFloat(value) <= 0.99) {
    color = "#dd874b";
  } else if (parseFloat(value) >= 0.1 && parseFloat(value) <= 0.5) {
    color = "#cf6822";
  } else {
    color = "#F9FADF";
  }

  return color;
};

export const timeAgo = (dateString) => {
  const date = new Date(dateString);
  const now = new Date();

  const secondsAgo = Math.floor((now - date) / 1000);
  const minutesAgo = Math.floor(secondsAgo / 60);
  const hoursAgo = Math.floor(minutesAgo / 60);
  const daysAgo = Math.floor(hoursAgo / 24);
  const weeksAgo = Math.floor(daysAgo / 7);

  if (secondsAgo < 60) {
    return `${secondsAgo} seconds ago`;
  } else if (minutesAgo < 60) {
    return `${minutesAgo} minutes ago`;
  } else if (hoursAgo < 24) {
    return `${hoursAgo} hours ago`;
  } else if (daysAgo < 7) {
    if (daysAgo === 1) {
      return `${daysAgo} day ago`;
    } else {
      return `${daysAgo} days ago`;
    }
  } else if (weeksAgo < 4) {
    return `${weeksAgo} weeks ago`;
  } else {
    return date.toLocaleDateString(); // Returns the date in the format MM/DD/YYYY
  }
};

export function separateCityAndState(location) {
  const lastHyphenIndex = location?.lastIndexOf("-");
  let city_name = location?.substring(0, lastHyphenIndex);
  const state_name = location?.substring(lastHyphenIndex + 1);
  city_name = city_name.replace(/-/g, " ");
  return { city_name, state_name };
}

export function formattedCityName(cityName) {
  return cityName && cityName.replace(/\s+/g, "-");
}

export const convertCityStateToSlug = (cityState) => {
  return cityState
    .trim() // Remove any leading or trailing whitespace
    .replace(/,/g, "") // Remove any commas
    .replace(/\s+/g, "-") // Replace spaces with hyphens
    .replace(/-+/g, "-"); // Replace multiple hyphens with a single hyphen
};

export const schoolgrades = {
  primaryarr: [
    "K-8",
    "K-12",
    "K-1",
    "K-5",
    "1-12",
    "K",
    "1",
    "K-6",
    "K-2",
    "3-6",
    "1-8",
    "1-6",
    "2-12",
    "K-7",
    "K-3",
    "K-4",
    "1-5",
    "3-5",
    "2-8",
    "3-12",
    "3-8",
    "4-5",
    "K-10",
    "1-10",
    "4",
  ],
  middlearr: [
    "6-12",
    "K-8",
    "6-8",
    "8-12",
    "7-12",
    "K-12",
    "6-7",
    "1-12",
    "7-8",
    "1-8",
    "2-12",
    "K-7",
    "6-9",
    "5-12",
    "5-8",
    "7-10",
    "7",
    "4-12",
    "2-8",
    "8-11",
    "3-12",
    "4-8",
    "3-8",
    "8",
    "K-10",
    "1-10",
    "7-9",
    "5-6",
    "7-11",
    "4-6",
    "6",
  ],
  higharr: [
    "6-12",
    "8-12",
    "7-12",
    "K-12",
    "10-12",
    "1-12",
    "9-12",
    "11-12",
    "12",
    "2-12",
    "5-12",
    "9-10",
    "7-10",
    "4-12",
    "8-11",
    "3-12",
    "9-11",
    "9",
    "K-10",
    "1-10",
    "7-11",
    "10",
  ],
};

export const horizontalLabels = {
  0: "0",
  0.5: "|",
  1: "1",
  1.5: "|",
  2: "2",
  2.5: "|",
  3: "3",
  3.5: "|",
  4: "4",
  4.5: "|",
  5: "5",
};

export function generateDescendingValues(maxValue, gap = 5000, count = 12) {
  const values = [];
  const finalMaxvalue = maxValue * 0.4;
  for (let i = 0; i < count; i++) {
    values.push(finalMaxvalue - i * gap);
  }
  return values.join(",");
}

export function getCitiesForRegion(regionName) {
  const regionCityMap = {
    Peninsula: [
      "Daly City",
      "Colma",
      "Brisbane",
      "South San Francisco",
      "San Bruno",
      "Millbrae",
      "Burlingame",
      "Hillsborough",
      "San Mateo",
      "Foster City",
      "Belmont",
      "San Carlos",
      "Redwood City",
      "Atherton",
      "Menlo Park",
      "East Palo Alto",
      "Palo Alto",
    ],
    "Silicon Valley": [
      "Los Altos",
      "Los Altos Hills",
      "Mountain View",
      "Sunnyvale",
      "Cupertino",
      "Santa Clara",
      "Saratoga",
      "Campbell",
      "Los Gatos",
      "San Jose",
    ],
    "East Bay": [
      "Albany",
      "Berkeley",
      "Emeryville",
      "Oakland",
      "Alameda",
      "Piedmont",
      "San Leandro",
      "Ashland",
      "Cherryland",
      "Hayward",
      "Castro Valley",
      "Union City",
      "Newark",
      "Fremont",
    ],
    Marin: [
      "Sausalito",
      "Belvedere",
      "Tiburon",
      "Mill Valley",
      "Corte Madera",
      "Larkspur",
      "San Anselmo",
      "Fairfax",
      "Ross",
      "Kentfield",
      "Greenbrae",
      "San Rafael",
      "Novato",
    ],
  };

  const cities = regionCityMap[regionName];
  if (!cities) return "";

  const formatted = cities.map((city) => `"${city}"`).join(",");
  return `(${formatted})`;
}
export const getOrderofCity = (filterValue) => {
  const filterMap = {
    npi: "npiscore_city",
    school: "schoolscore_city",
    crime: "crimescore_city",
    medianprice: "medianpricescore_city",
    value: "valuescore_city",
    appreciation: "appreciation_city",
  };

  return filterMap[filterValue] || filterValue;
};
